import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

export const DBO_ACCOUNTS_QUERY_KEY = 'dbo-accounts';

const getDbAccountsQueryOptions = () =>
  queryOptions({
    queryKey: [DBO_ACCOUNTS_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.dbo.getAccounts();
      return data;
    },
  });

export const useDbAccountsQuery = () => {
  return useQuery(getDbAccountsQueryOptions());
};
